import { useState, useEffect, useCallback } from "react";
import { fetchStaffDetail, fetchStaffServiceItems } from "@/api/guide";
import type { StaffDetail } from "@/api/guide";
import type { StaffServiceItem } from "@/api/guide";

interface UseGuideDetailOptions {
  guideId: number;
}

export function useGuideDetail({ guideId }: UseGuideDetailOptions) {
  const [guide, setGuide] = useState<StaffDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>("");
  const [serviceItems, setServiceItems] = useState<StaffServiceItem[]>([]);

  /** 获取达人详情 */
  const fetchDetail = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const data = await fetchStaffDetail({ staff_id: guideId });
      setGuide(data);
    } catch (e) {
      const msg = e instanceof Error ? e.message : "获取达人详情失败";
      console.error("[guide-detail] 获取达人详情失败:", e);
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, [guideId]);

  /** 获取服务项目列表 */
  const fetchServiceItems = useCallback(async (staffId: number | string) => {
    try {
      const items = await fetchStaffServiceItems({ staff_id: staffId });
      setServiceItems(items);
    } catch (e) {
      console.error("[guide-detail] 获取服务项目失败:", e);
    }
  }, []);

  useEffect(() => { fetchDetail(); }, [fetchDetail]);

  // 达人详情加载成功后获取服务项目
  useEffect(() => {
    if (guide?.id) fetchServiceItems(guide.id);
  }, [guide?.id, fetchServiceItems]);

  return { guide, loading, error, serviceItems };
}
